'use client';
import Image from 'next/image';
import Link from 'next/link';

const Ourservice = ({ title, subtitle, description, services }) => {
  return (
    <div>
      <section className="py-10 md:py-16 lg:py-16">
        <div className="max-w-screen-xl mx-5 lg:mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-6 lg:gap-10 items-center justify-between mb-6 md:mb-10">
            <div>
              <p className="font-semibold text-blue-600 text-base md:text-lg uppercase">
                {title}
              </p>
              <h2 className="font-semibold text-black my-3">{subtitle}</h2>
            </div>
            <div>
              <p>{description}</p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6 lg:gap-10 items-stretch justify-between relative z-50">
            {services.map((service, index) => (
              <Link href={service.link} key={index}>
                <div
                  className="column-tint p-6 md:p-10 rounded-md z-20 before:-z-10 transform transition duration-300 hover:scale-105 hover:shadow-lg"
                  style={{ background: `url("${service.backgroundImage}")` }}
                >
                  <div className="mt-32 md:mt-40 lg:mt-64">
                    <Image
                      src={service.icon}
                      width={48}
                      height={48}
                      className="object-cover w-12 h-12 mb-4"
                      alt={service.title}
                    />
                    <h6 className="text-white font-medium mb-0">
                      {service.title}
                    </h6>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Ourservice;
